<template>
  <!-- 季度选择时间控件 -->
  <div class="season-picker">
    <season-picker v-model="beginTime"  @change="changeTime" :placeholder="$t('quarterlyRangePicker.kai_shi_ji')" :unbindOrgTime="unbindOrgTime"></season-picker>
     <span class="bar">-</span>
    <season-picker v-model="endTime" @change="changeTime" :placeholder="$t('quarterlyRangePicker.jie_shu_ji')" :unbindOrgTime="unbindOrgTime"></season-picker>
  </div>
</template>
<script>
/**
 * @file:  View 组件 季节选择控件
 * @description: UI组件  可选择季节
 * @api: valueArr : 季度value defalut['01-03', '04-06', '07-09', '10-12'] 默认值待设置
 * 代码中注释部分是组件原默认时间配置，我这里做了更改，但是原设置可以参考
 */
import seasonPicker from '@/components/seasonPicker.vue';

export default {
  name: 'SeasonRangpicker',
  props: {
    value: {
      type: Array,
      default() {
        return [];
      }
    },
    unbindOrgTime: {
      type: String,
      default() {
        return '';
      }
    }
  },
  components: {
    seasonPicker,
  },
  data() {
    return {
      beginTime: this.value[0],
      endTime: this.value[1],
      year: new Date().getFullYear(), // input显示时间，会随着用户操作改变
      month: new Date().getMonth() + 1, // 当前月份，不变
      maxSeason: ''
    };
  },

  mounted() {
    if (this.value) {
      this.beginTime = this.value[0];
      this.endTime = this.value[1];
    }
    if (this.month <= 3) {
      this.maxSeason = '01';
      this.season = 1;
    } else if (this.month > 3 && this.month <= 6) {
      this.maxSeason = '02';
      this.season = 2;
    } else if (this.month > 6 && this.month <= 9) {
      this.maxSeason = '03';
      this.season = 3;
    } else if (this.month > 9 && this.month <= 12) {
      this.maxSeason = '04';
      this.season = 4;
    }
  },
  watch: {
    value: function (val) {
      if (val) {
        this.beginTime = val[0];
        this.endTime = val[1];
      }

    }
  },
  methods: {
    selectSeason(i) {
      const that = this;
      that.season = i + 1;
      const arr = that.valueArr[i];
      const seasonValue = that.getValue(`${that.year}-${arr}`);
      that.showSeason = false;
      this.showValue = `${this.year} / ${this.season}`;
      that.$emit('chooseSeason', seasonValue); // 每次选择时间都将当前选择时间发送到父组件
      this.$emit('input', seasonValue);
      this.$emit('change', seasonValue);
    },

    changeTime() {
      if (!this.endTime && this.beginTime) {
        // 补头
        this.endTime = `${this.year}-${this.maxSeason}`;
      } else if (!this.beginTime && this.endTime) {
        // 补尾
        this.beginTime = this.endTime;
      }
      // console.log(this.endTime, this.beginTime, this.endTime <= this.beginTime);
      const maxTime = this.endTime <= this.beginTime ? this.beginTime : this.endTime;
      this.beginTime = this.endTime <= this.beginTime ? this.endTime : this.beginTime;
      this.endTime = maxTime;
      const Timer = [`${this.beginTime}`, `${this.endTime}`];
      this.$emit('input', Timer);
      this.$emit('change', Timer);
    },


  }
};
</script>

<style lang="scss">
.season-picker{
  display: inline;
  .firstBtn {
    height: 30px;
    line-height: 34px;
    width: 100%;
    text-align: center;
  }
  .bar{
    font-size: 20px;
    line-height: 40px;
    margin:0 3px;
    width: 20px;
    display: inline-block;
text-align: center;
  }
  .text {
    text-align: center;
    margin: 15px 0 10px;
  }
  .item {
    text-align: center;
  }
}
.colorDis {
  color: #999 !important;
}
.season-picker {
  .el-card__header {
    padding: 12px;
  }
}
</style>
